import React from 'react';

import { View } from "react-native";

import * as _cr from "./_cr";
import { useNgnz } from "./_csNgn";
import * as _hm from "./_hm";
import * as _hmDTM from "./_hmDTM";
import * as _ht from "./_ht";
import * as _gv from "./_gv";

import * as icm from "./icm";

export type tPagez = {
  [_pageName: _ht.s]: {
    page: _ht.o,
    text: _ht.s,
  }
};

export const R = (pz: {
  sRz: _ht.dz,
  cz: {
    itlPageName: _ht.s,
    pagez: tPagez,
    ectOnce?: () => void,
  },
}) => {

  const _gUserz = _gv.useUserz();
  const _sNgnz = useNgnz();

  React.useEffect(() => {
    _sNgnz.setPagez(
      pz.cz.pagez,
    );
    if (pz.cz.ectOnce) pz.cz.ectOnce();
  }, [])

  const _pageName = _sNgnz.getPageName() ?? pz.cz.itlPageName;

  if ( _pageName != pz.cz.itlPageName ) {
    const _ls = window.performance.getEntriesByType("navigation");
    const _type = _hm.get1(_ls, {}).type;
    if (_type != 'reload') {
      const _ref = document.referrer;
      if (_ref.length == 0 || !_ref.match( new RegExp( "^https?://" + window.location.hostname, 'i' ))) {
        const _drc = _hmDTM.getDrcMnt(_gUserz.crt.ornDtm);
        if ( _drc > 1440 ) { // 60 * 24
          icm.lot(_sNgnz);
        }
      }
    }
  }

  return (
    _cr.c(View, {
      style: {
        width: '100%',
        height: '100%',
      }
    },
      pz.cz.pagez[_pageName] ?
      _cr.c(pz.cz.pagez[_pageName]?.page, {
        sRz: pz.sRz,
      })
      : undefined
    )
  );
};
